(function(){
  var root=document.getElementById('jhp-lander');
  if(!root) return;

  var variantId=43533787103310;
  var sellingPlan=2655420494;
  var giftVariantIds=[41679873769550,42933942616142];
  var discountCode='LTO-CREATINESTICK';
  var giftDiscountCode='FREESTARTERKIT';
  var ctaDefault='TRY JIVE TODAY';
  var busy=false;

  function setCtaText(text){
    root.querySelectorAll('.jhp-cta-text').forEach(function(el){el.textContent=text});
  }

  function resetCtaText(){
    root.querySelectorAll('.jhp-cta-text').forEach(function(el){el.textContent=el.dataset.default||ctaDefault});
  }

  function addItems(items){
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:items})
    }).then(function(response){
      if(!response.ok) throw new Error('Cart error');
      return response.json();
    });
  }

  window.jhpAddToCart=function(){
    if(busy) return;
    busy=true;
    setCtaText('CHECKING AVAILABILITY...');
    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
      .then(function(){
        setCtaText('RESERVING YOUR ORDER...');
        return addItems([{id:variantId,quantity:1,selling_plan:sellingPlan}]);
      })
      .then(function(){
        setCtaText('ADDING YOUR FREE GIFTS...');
        return addItems(giftVariantIds.map(function(id){return {id:id,quantity:1}})).catch(function(){});
      })
      .then(function(){
        setCtaText('APPLYING DISCOUNT...');
        return fetch('/discount/'+giftDiscountCode,{method:'GET'});
      })
      .then(function(){
        setCtaText('REDIRECTING TO CHECKOUT...');
        window.location.href='/checkout?discount='+discountCode;
      })
      .catch(function(error){
        console.error(error);
        busy=false;
        resetCtaText();
      });
  };

  root.querySelectorAll('.jhp-faq-q').forEach(function(question){
    question.addEventListener('click',function(){
      var item=this.parentElement;
      var wasOpen=item.classList.contains('jhp-open');
      root.querySelectorAll('.jhp-faq-item.jhp-open').forEach(function(openItem){openItem.classList.remove('jhp-open')});
      if(!wasOpen) item.classList.add('jhp-open');
    });
  });

  var sticky=document.getElementById('jhpSticky');
  var heroCta=document.getElementById('jhpHeroCta');
  function updateSticky(){
    if(sticky&&heroCta) sticky.classList.toggle('jhp-visible',heroCta.getBoundingClientRect().bottom<0);
  }
  window.addEventListener('scroll',updateSticky,{passive:true});
  updateSticky();

  root.querySelectorAll('a[href^="#"]').forEach(function(link){
    link.addEventListener('click',function(event){
      var target=document.querySelector(this.getAttribute('href'));
      if(target){
        event.preventDefault();
        target.scrollIntoView({behavior:'smooth',block:'start'});
      }
    });
  });

  if(window.lucide) window.lucide.createIcons();
})();
